export default {
	methods: {
		setLoadingStatus(status) {
			this.$root.$emit('setLoadingStatus', { status: status });
		},
	},
};
